import { Controller } from 'stimulus'

export default class RowLinkController extends Controller {
  static targets = [ 'link' ]

  visit() {
    this.linkTarget.click()
  }
}